module.exports = __webpack_public_path__ + "static/media/bonarka06.6141dd87.jpg";